import { COLOR, histogram, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'BEARS',
  version: 1,
  label: 'Bears Power',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 280,
  inputs: [period('timeperiod', 13)],
  outputs: [histogram('bears', 'Bears', COLOR.green, COLOR.red)],
  talib: { functions: ['SUB', 'EMA'], expr: 'SUB(low, EMA(close, timeperiod={timeperiod}))' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
